import React from 'react';
import { parseMessages } from '../../utilityHelper';
import { Loader, Row, Col, Button, Container, Card } from "kepler";
import ReactHtmlParser from 'react-html-parser';
import DashboardMonthPayoutTable from '../components/dashboardMonthPayoutTable';
import DashboardPDTable from '../components/dashboardPD';

const dashboardData = $('body').data(),
    dashboardPageMsg = parseMessages('dashboard');
let notLoading, notPDLoading;

export default class PPGFDashboardComp extends React.Component {
	constructor(props){
        super(props);
        this.state = {
            dashboardData: dashboardData.body,
            rowIndex: '',
            currentTab: 'donations',
            cyloader: true,
            pdloader: true,
            pdTableLoader: true,
            monthWiseLoader: true
		}
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.renderPendingDonationsData = this.renderPendingDonationsData.bind(this);
    }
    componentDidMount() {
        let self = this,
			csrf = $("body").attr("data-csrf"),
			data = {
                _csrf: csrf
            },
            monthwiseData = {
                _csrf: csrf,
                pageNo: dashboardData.dashboarddata.pageNo
            },
            pdData = {
                _csrf: csrf,
                pageNumber: dashboardData.dashboarddata.pageNo
            }
        this.renderCurrentYearTotal(data);
        this.renderPendingDonationsTotal(data);
        this.renderMonthWisePayoutTotal(monthwiseData);

        //Tabs Menu Click
        $(".tabs-menu a").click(function (event) {
            event.preventDefault();
            let clicked = this,
                tab = $(clicked).attr("href");
            $(clicked).parent().addClass("current");
            $(clicked).parent().siblings().removeClass("current");
            $(".tab-content").not(tab).css("display", "none");
            $(tab).fadeIn('slow');
            if (tab == '#payoutSummary') {
                self.setState({
                    currentTab: 'donations',
                    monthwisePayoutData: [],
                    pendingDonationsData: []
                });
            } else {
                self.setState({
                    currentTab: 'pendingDonations',
                    monthwisePayoutData: [],
                    pendingDonationsData: []
                });
                if ($(clicked).attr('class').indexOf('loaded') < 0) {
                    $(clicked).addClass('loaded');
                    self.renderPendingDonationsData(pdData);
                }
            }
        });
        //On scroll for Donation History and PD
        $(window).on('scroll', function () {
            let $elem = $('.dashWrapper'),
                docViewTop = $(window).scrollTop(),
                docViewBottom = docViewTop + $(window).height(),
                elemTop = $elem.offset().top,
                elemBottom = elemTop + $elem.height();
            
            if (self.state.currentTab === 'donations' && (elemBottom < docViewBottom) && notLoading) {
                notLoading = false;
                self.renderMonthWisePayoutTotal(monthwiseData);
            } else if (self.state.currentTab === 'pendingDonations' && (elemBottom < docViewBottom) && notPDLoading) {
                notPDLoading = false;
                self.renderPendingDonationsData(pdData);
            }
        });
    }

    renderCurrentYearTotal(data) {
        let self = this;
        $.post("/givingfund/renderCurrentYearTotal", data, function (result) {
            if (result.status === 'OK') {
                self.setState({
                    cyloader: false,
                    totalYearAmount: result.data.totalPayout.total_amount,
                    currentYear: result.data.totalPayout.year
                });
            } else {
                self.setState({
                    cyloader: false
                });
            }
        }).fail(function () {
            self.setState({
                cyloader: false
            });
        });
    }
    renderPendingDonationsTotal(data) {
        let self = this;
        $.post("/givingfund/renderPendingDonationTotal", data, function (result) {
            if (result.status === 'OK') {
                self.setState({
                    pdloader: false,
                    totalPDAmount: result.data.total_amount
                });
            } else {
                self.setState({
                    pdloader: false
                });
            }
        }).fail(function () {
            self.setState({
                pdloader: false
            });
        });
    }
    renderMonthWisePayoutTotal(data) {
        let self = this;
        self.setState({
            monthWiseLoader: true,
            monthwisePayoutData: [],
            pendingDonationsData: []
        });
        $.post("/givingfund/renderMonthwisePayoutTotal", data, (result) => {
            if (result.status === 'OK' && result.data && result.data.payouts.length == 0) {
                notLoading = false;
                self.setState({
                    monthWiseLoader: false,
                    monthwisePayoutData: result.data.payouts ? result.data.payouts : [],
                    monthWisePageNo: data.pageNo,
                    pendingDonationsData: []
                });
            } else {
                notLoading = true;
                data.pageNo = parseInt(data.pageNo) + 1;
                self.setState({
                    monthWiseLoader: false,
                    monthwisePayoutData: result.data.payouts ? result.data.payouts : [],
                    monthWisePageNo: data.pageNo,
                    monthWiseLoaderSize: 'md',
                    pendingDonationsData: []
                });
            }
        }).fail(() => {
            self.setState({
                monthWiseLoader: false
            });
        });
    }
    renderPendingDonationsData(data) {
        let self = this;
        self.setState({
            pdTableLoader: true
        });
        $.post("/givingfund/dashboardForPendingDonations", data, (result) => {
            if (result.status === 'OK' && result.data && result.data.donation_info.length == 0) {
                notPDLoading = false;
                self.setState({
                    pdTableLoader: false,
                    pendingDonationsData: result.data.donation_info ? result.data.donation_info : [],
                    pdPageNo: data.pageNumber,
                    monthwisePayoutData: [],
                });
            } else {
                $('.pendingDonations').removeClass('hide');
                notPDLoading = true;
                data.pageNumber = parseInt(data.pageNumber) + 1;
                self.setState({
                    pdTableLoader: false,
                    pendingDonationsData: result.data.donation_info ? result.data.donation_info : [],
                    pdPageNo: data.pageNumber,
                    pdTableLoaderSize: 'md',
                    monthwisePayoutData: [],
                });
            }
        }).fail(() => {
            self.setState({
                pdTableLoader: false
            });
        });
    }

    copyToClipboard () {
        let $temp = $("<input>");
        $("body").append($temp);
        $temp.val($('#fundraisingLink').text()).select();
        document.execCommand("copy");
        $temp.remove();
    }

	render() {
        let tab1Txt =  dashboardPageMsg.dashboard.tab1Txt ? dashboardPageMsg.dashboard.tab1Txt.replace('{currentYear}', this.state.currentYear) : '',
        payoutDateTxt = dashboardPageMsg.dashboard.P1.replace('{PAYOUT_DATE}', dashboardData.dashboarddata.PAYOUT_DATE),
        pendingDonationsText = dashboardPageMsg.dashboard.P2.replace('{PAYOUT_DATE}', dashboardData.dashboarddata.PAYOUT_DATE),
        eBaySalesCharity;
        const countryCode = dashboardData.country;
        if (countryCode == 'US' || countryCode == 'GB') eBaySalesCharity = true;

		if(!this.state.dashboardData.errorType){
			return ( 
            <Container id="dashboard">
                <Row>
                    <Col sm="1/3">
                        <Card style={{'padding': '20px 0 20px 20px'}}>
                            <h2>{dashboardPageMsg.dashboard.fundraising}</h2>
                            <div className="transactionTabs tabs-container" id="transactionTabs">
                                <ul className="tabs-menu">
                                    <li className="current">
                                        <Loader size='md' show={this.state.cyloader} priority={10} opacity={1} id='cyloader'>{dashboardPageMsg.dashboard.loadingCurrentYearTotal}</Loader>
                                        <a href="#payoutSummary" data-pa-click="ppgf-dashboard-donation-history">
                                            <p className="payoutAmount">{this.state.totalYearAmount}</p>
                                            <p className ="payoutText">{tab1Txt}</p>
                                        </a>
                                    </li>
                                    <li>
                                        <Loader size='md' show={this.state.pdloader} priority={10} opacity={1} id="loadPD">{dashboardPageMsg.dashboard.loadingPDTotal}</Loader>
                                        <a href="#pendingSummary" className="pendingTxnTab" data-pa-click="ppgf-dashboard-pending-donations">
                                            <p className="payoutAmount pdTotalAmount">{this.state.totalPDAmount}</p>
                                            <p className="payoutText">{dashboardPageMsg.dashboard.pendingTxn}</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                        <Card id="resources" className="resources">
                            <h2>{dashboardPageMsg.dashboard.resources.label}</h2>
                            <div className="row">
                                <p className="icon icon-heart">
                                    <a href={dashboardData.countrylinks.mpphomepage} target="_blank">
                                        {dashboardPageMsg.dashboard.resources.about}
                                    </a>
                                </p>
                                {eBaySalesCharity ? (<div>
                                <p><strong>{dashboardPageMsg.dashboard.resources.ebaysales}</strong></p>
                                <p className="icon icon-speeding-cart">
                                    <a href={dashboardData.countrylinks.ebayCharityPage} target="_blank">
                                        {dashboardPageMsg.dashboard.resources.ebaycharity}
                                    </a>
                                </p>
                                </div> ) : ('')
                                } 
                                <p>
                                    <strong>{dashboardPageMsg.dashboard.resources.share}</strong>
                                </p>
                                <p>{dashboardPageMsg.dashboard.resources.fundraising}</p>
                                <div className="roundedCorner">
                                    <div id="fundraisingLink">
                                    {dashboardData.countrylinks.fundraiser}/{dashboardData.dashboarddata.giving_fund_info.shared_nonprofit_id}
                                    </div>
                                    
                                    <div className="copyFRLink" onClick={this.copyToClipboard}>{dashboardPageMsg.dashboard.resources.copy}
                                    </div>                                    
                                </div>
                            </div>
                        </Card>
                    </Col>
                    <Col sm="2/3" className="dashWrapper">
                        <Card id="payoutSummary" className="tab-content activity">
                            <h2>{dashboardPageMsg.dashboard.donationHistory}</h2>
                            <p className="firstchild">{ReactHtmlParser(payoutDateTxt)}</p>
                            <DashboardMonthPayoutTable monthwisePayoutData={this.state.monthwisePayoutData} pageNo={this.state.monthWisePageNo} rowInx={this.state.rowInx} dashboardPageMsg={dashboardPageMsg} />
                            <div className="loaderWrapper">
                                <Loader size={this.state.monthWiseLoaderSize} show={this.state.monthWiseLoader} priority={10} opacity={0.5} id="mWL" />
                            </div>
                        </Card>
                        <Card id="pendingSummary" className="tab-content activity">
                            <Row>
                                <Col sm="1/2">
                                    <h2>{dashboardPageMsg.dashboard.tab2desc}</h2>
                                </Col>
                                <Col sm="1/2">
                                    <Button type="secondary" href="downloadDonations" size="md" className="pull-right">{dashboardPageMsg.dashboard.downloadcsv}</Button>
                                </Col>
                            </Row>
                            <p className="firstchild">{pendingDonationsText}</p>
                            <DashboardPDTable pendingDonationsData={this.state.pendingDonationsData} pageNo={this.state.pdPageNo}
                            rowInx={this.state.rowInx} dashboardPageMsg={dashboardPageMsg} />
                            <div className="loaderWrapper">
                                <Loader size={this.state.pdTableLoaderSize} show={this.state.pdTableLoader} priority={10} opacity={0.5} />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
			);
		} else {
			return (<div><ErrorComponent errorType={this.state.dashboardData.errorType}/></div>);
		}
	}
}


// WEBPACK FOOTER //
// ./ppgf/components/dashboard.js